function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M265.6 153c-9.5-7.7-21.8-11.2-38.9-11.2v-28.4H70.8v141.7H42.5l.1-226.7h28.3L120.4 85h56.7l48.6-56.7h1V0H70.8L14.2.1l-.1 283.3h212.6v-28.3c16.7 0 29.5-3.8 39-11.6 11.8-9.7 17.7-24.8 17.7-45.1 0-20.6-6-35.9-17.8-45.4zM188.4 28.4l-24.3 28.3h-30.8l-24.8-28.3h79.9zm10 226.7H99.2V141.7h99.2v113.4zm28.3-28.3v-56.7c10.1 0 17 1.6 21.1 4.9 4.8 3.9 7.3 11.8 7.3 23.4 0 21.3-7.2 28.4-28.4 28.4z"
})));